import React from "react";
import { create } from "zustand";
import Category from "../Components/Home/Category";
import { ProductsAPI } from "../Helpers/ConfigProvider";

const useProductStore = create((set, get) => ({
  products: [],
  itemsList: [],
  containersList: [],
  categoriesList: [],
  loading: false,
  errors: [],
  product: null,
  IsCategory: false,
  IsProduct: false,
  wholeSaleItems: [],
  loadingWholeSale: false,

  getProducts: async () => {
    console.log("API URL:", ProductsAPI);

    const response = await fetch(`${ProductsAPI}/Products`);
    const data = await response.json();
    set({ products: data });
  },
  getItemsPaged: async (page, pageSize) => {
    

    set({ loading: true });
    try {
      const response = await fetch(
        `${ProductsAPI}/Products?page=${page}&pageSize=${pageSize}`
      );
      if (!response.ok) {
        try {
          const errors = await response.json();
          if (Array.isArray(errors) && errors[0]?.ErrorMessage) {
            set({ items: [], errors: errors.map((e) => e.ErrorMessage) });
          } else if (errors?.errormessage) {
            set({ items: [], errors: [errors.errormessage] });
          } else {
            set({
              items: [],
              errors: [
                { message: "Failed to fetch items", status: response.status },
              ],
            });
          }
        } catch (e) {
          set({
            items: [],
            errors: [
              { message: "Failed to fetch items", status: response.status },
            ],
          });
        }
        return get().errors;
      }
      const data = await response.json();
      set({ products: data });
      return data;
    } catch (error) {
      console.error("Error fetching paged items:", error);
    } finally {
      set({ loading: false });
    }
  },

  getProductsByCategoryOrFriendlyName: async (categoryId) => {
    if (!categoryId) {
      return [];
    }


    // Check if we already have this category's items cached
    if (get().categoriesList.some((cat) => cat.CategoryName === categoryId)) {
      const category = get().categoriesList.find(
        (cat) => cat.CategoryName === categoryId
      );


      set({          
          product: null,
          IsProduct: false,
          IsCategory: true,
        });

      return category.Items;
    }

    // Prevent multiple simultaneous loads
    if (get().loading) {
      return;
    }
    set({ loading: true, IsCategory: false, IsProduct: false, product: null });

    const response = await fetch(`${ProductsAPI}/Products/${categoryId}`);
    // Handle non-OK responses
    if (!response.ok) {
      const error = await response.text();
      set({ errors: [...get().errors, error] });
      return;
    }

    const data = await response.json();
    set({ loading: false });


    if (data == null){
        set({
          categoriesList: [],          
          product: null,
          IsProduct: false,
          IsCategory: false,
        });
        return null;
    }

    
      if (data.IsCategory) {
        const categoryItem = {
          CategoryName: categoryId,
          Items: data.Products,
        };
        set({
          categoriesList: [...get().categoriesList, categoryItem],          
          product: null,
          IsProduct: false,
          IsCategory: true,
        });
        return categoryItem;
      } 
      else {
        if (data.Products.length === 0) {
          set({
            errors: [...get().errors, "Product not found"],
            product: null,            
            IsProduct: false,
          });
        } else {
          set({
            product: data.Products[0],            
            IsProduct: true,
            IsCategory: false,
        });
        return data;
      }
    }



    // set({ products: data });
    return data;
  },
  getProductByCategoryAndFriendlyName: async (categoryId, friendlyName) => {
    if (!friendlyName) {
      return null;
    }

    if (get().loading) {
      return;
    }

    set({ loading: true, IsCategory: false, IsProduct: false });
    const response = await fetch(
      `${ProductsAPI}/Products/${categoryId}/${friendlyName}`
    );
    if (!response.ok) {
      const error = await response.text();
      set({ errors: [...get().errors, error], loading: false });
      return;
    }

    const data = await response.json();
    set({ loading: false });
    if (data !== null) {
      set({ product: data, IsProduct: true, IsCategory: false });
    }

    return data;
  },
    getWholeSaleItems: async (page, pageSize) => {
    

    if (get().loadingWholeSale) return; // Prevent multiple simultaneous fetches

    set({ loadingWholeSale: true });
    try {

      const pageQuery = page ? `page=${page}` : "";
      const pageSizeQuery = pageSize ? `pageSize=${pageSize}` : "";
      const queryString = [pageQuery, pageSizeQuery].filter(Boolean).join("&");

      const response = await fetch(`${ProductsAPI}/Products/WholeSale${queryString ? "?" + queryString : ""}`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      set({ wholeSaleItems: data });
      return data;
    } catch (error) {
      console.error("Error fetching wholesale items:", error);
    } finally {
      set({ loadingWholeSale: false });
    }
  },
}));

export default useProductStore;
